<template>
  <div class="emoji-wrap">

    <input v-if="isInput"
           v-bind="$attrs"
           type="text"
           ref="inputElement"
           :class="classInput"
           v-bind:value="value"
           v-on:input="$emit('input', $event.target.value)"
    >

    <textarea v-else
              v-bind="$attrs"
              ref="inputElement"
              name="textarea"
              cols="10"
              placeholder="Write a Message..."
              class="with-border"
              v-bind:value="value"
              v-on:input="$emit('input', $event.target.value)"
              required
    ></textarea>

    <div
        class="emoji-invoker"
        @click.stop="toggle"
        :class="{active: display}"
    >

      <svg
          height="24"
          width="24"
          viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
      </svg>

    </div>

    <div class="emoji-picker"
         :class="{'emoji-picker-visible': display}"
         v-click-outside="hide">
      <div class="emoji-picker-triangle"></div>
      <div class="emoji-picker-categories">
        <a v-for="(emojiGroup, category) in emojis"
           :key="category"
           href="#"

           v-scroll-to="{el: `#emoji-${category.replace(/\s/gi, '').toLowerCase()}`, container: '.emojis-list'}"
        >{{ emojiGroup[Object.keys(emojiGroup)[0]] }}</a>
      </div>

      <div class="emoji-picker__search">
        <input type="text" class="with-border" placeholder="Search" v-model="search" v-focus>
      </div>
      <div class="emojis-list" >
        <div v-for="(emojiGroup, category) in emojis"
             :key="category"
             class="emoji-category-item"
             :id="`emoji-${category.replace(/\s/gi, '').toLowerCase()}`">
          <h5>{{ category }}</h5>
          <div class="emojis">
                <span
                    v-for="(emoji, emojiName) in emojiGroup"
                    :key="emojiName"
                    @click="insert(emoji)"
                    :title="emojiName"
                >{{ emoji }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import emojis from 'vue-emoji-picker/src/emojis'

  export default {
    inheritAttrs: false,
    props: {
      classInput: {
        type: String,
        'default': 'form-control el-input__inner',
      },
      value: {
        type: String,
        required: false,
        'default': '',
      },
      isInput: {
        type: Boolean,
        'default': true,
      },
      emojiTable: {
        type: Object,
        required: false,
        'default'() {
          return emojis
        },
      },
    },
    data() {
      return {
        display: false,
        search: ''
      }
    },
    computed: {
      emojis() {
        if (this.search) {
          const obj = {};

          for (const category in this.emojiTable) {
            obj[category] = {};

            for (const emoji in this.emojiTable[category]) {
              if (new RegExp(`.*${this.search}.*`).test(emoji)) {
                obj[category][emoji] = this.emojiTable[category][emoji]
              }
            }

            if (Object.keys(obj[category]).length === 0) {
              delete obj[category]
            }
          }

          return obj
        }

        return this.emojiTable
      },
    },
    methods: {
      insert(emoji) {
        this.$refs.inputElement.focus();
        // document.querySelector('.emoji-wrap textarea').focus();
        document.execCommand("insertText", false, emoji);
        this.hide();
//        this.$emit('emoji', emoji)
      },
      toggle() {
        this.display = !this.display
      },
      hide() {
        this.display = false
      },
      escape(e) {
        if (this.display === true && e.keyCode === 27) {
          this.display = false
        }
      },
    },
    directives: {
      focus: {
        inserted(el) {
          el.focus()
        },
      },
      'click-outside': {
        bind(el, binding) {
          if (typeof binding.value !== 'function') {
            return
          }

          const bubble = binding.modifiers.bubble;
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          };
          el.__vueClickOutside__ = handler;

          document.addEventListener('click', handler)
        },
        unbind(el) {
          document.removeEventListener('click', el.__vueClickOutside__);

          el.__vueClickOutside__ = null;
        },
      },
    },
    mounted() {
      document.addEventListener('keyup', this.escape)
    },
    destroyed() {
      document.removeEventListener('keyup', this.escape)
    },
  }
</script>

<style lang="sass" scoped>
  @keyframes show-emoji
    0%
      transform: translateY(50px)
    70%
      transform: translateY(-7px)
    100%
      transform: translateY(0)

  .emoji-wrap
    &>input
      padding-right: 35px !important
    position: relative
    .emoji-invoker
      position: absolute
      bottom: 2px
      right: 4px
      width: 32px
      height: 32px
      padding: 4px
      border-radius: 50%
      cursor: pointer
      transition: all 0.2s
      > svg
        fill: #e0e0e0
      &:hover,
      &.active
        transition: all ease 0.2s
        transform: scale(1.1)
      &.active path
        fill: #0d70e3

    .emoji-picker
      position: absolute
      z-index: 100
      border: 1px solid #e0e0e0
      width: 300px
      right: -305px
      top: 0
      box-sizing: border-box
      border-radius: 4px
      background: #fff
      box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.12)
      display: none
      &.emoji-picker-visible
        display: block
        animation: show-emoji .2s
      @media (max-width: 950px)
        width: 100%
        right: auto
        top: auto
        margin-top: -5px

    .emoji-picker-triangle
      width: 10px
      height: 10px
      border-radius: 2px
      border: 1px solid #e0e0e0
      transform: rotate(45deg)
      position: absolute
      background-color: white
      left: -5px
      top: 15px
      @media (max-width: 950px)
        left: 15px
        top: -5px

    .emoji-picker-categories
      display: flex
      border-radius: 4px
      padding: 4px 8px
      position: relative
      background-color: white
      justify-content: space-between
      a
        padding: 2px 6px
        border-radius: 4px
        &:hover,
        &.active
          text-decoration: none
          background-color: #ededed

    .emoji-picker__search
      padding: 0 8px 8px
      input
        display: block
        width: 100%
        /*outline: none*/
        height: 30px
        line-height: 20px
        padding: 0 10px
        margin: 0

    .emojis-list
      height: 150px
      overflow: auto
      padding: 0 8px
      position: relative

    .emoji-picker
      h5
        margin-bottom: 0
        margin-top: 4px
        color: #b1b1b1
        /*text-transform: uppercase*/
        font-size: 0.8rem
        cursor: default
      .emojis
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        &:after
          content: ""
          flex: auto
        span
          padding: 0.2rem
          cursor: pointer
          border-radius: 5px
          &:hover
            background: #ececec
            cursor: pointer
</style>
